module.exports = __webpack_public_path__ + "img/gift-card-icon.b2bd21c4.svg";